
import { updateAppConfig } from '#app'
import { defuFn } from '/Users/yuto.yasuoka/Project/chirashi-viewer/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "nuxt": {
    "buildId": "1884205e-af11-4ee1-9547-c1bf4013b9f2"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /* #__PURE__ */ defuFn(inlineConfig)
